import React, { useState, forwardRef, useEffect } from "react";
import "../../pages/customerMaster/customerMaster.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    placeholder="DD/MM/YY"
    ref={ref}
  ></input>
));
// datepicker end
const CustomerDocuments = ({
  DocumentsName,
  formValues,
  formError,
  removeAttachedFile,
  handleDocumentChange,
  handleAttachmentDate,
  documentList,
  setFormValues,
  docError,
}) => {
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);

  const progressRef = React.useRef(() => { });
  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // mui progress bar end

  const documentListFile = () => {
    if (!documentList?.length) return;

    const docs = documentList.map((docx) => {
      const docc = formValues?.customerDocument?.find(
        (obj) => obj?.documentId === docx?.id
      );

      return {
        ...docx,
        fileName: docc?.docuUrl || "",
        fileObj: null,
        file: {
          documentId: docx?.id,
          docuUrl: docc?.docuUrl || "",
          expDate: docc?.expDate ? new Date(docc?.expDate) : null,
          isActive: docx?.isActive,
        },
      };
    });
    setFormValues((prevValues) => ({
      ...prevValues,
      docs,
    }));
  };

  useEffect(() => {
    documentListFile();
  }, [documentList,formValues?.customerDocument]);

  return (
    <>
      <div className="card documents-card mt-1 mb-2">
        <div className="card-header">
          <h2>{DocumentsName}</h2>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div className="customer-documents-table-sec">
                <table className="table table-striped table-borderless">
                  <tbody>
                    {formValues?.docs?.length > 0 ? (
                      formValues?.docs?.map((doc, ind) => (
                        <tr key={doc?.id}>
                          <td className="text-align" style={{ width: "25%" }}>
                            {doc?.documentName}
                          </td>
                          <td>
                            <div id="file-upload-form" className="upload-btn">
                              <input
                                id={`file-upload-attachment-document-${doc?.id}`}
                                type="file"
                                name="commercialRegistration"
                                accept=".pdf"
                                onChange={(e) =>
                                  handleDocumentChange(e, doc?.id)
                                }
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                              />
                              {doc?.fileName == "" ? (
                                <label
                                  for={`file-upload-attachment-document-${doc?.id}`}
                                  id="file-drag"
                                >
                                  <p>Attach File</p>
                                  <span class="material-icons-outlined">
                                    file_upload
                                  </span>
                                </label>
                              ) : (
                                <label>
                                  <p>{doc?.fileName}</p>
                                  <i
                                    className="fas fa-times"
                                    onClick={(e) =>
                                      removeAttachedFile(doc?.id, ind)
                                    }
                                  ></i>
                                </label>
                              )}
                            </div>
                          </td>
                          <td style={{ width: "25%" }}>
                            <div className="d-flex justify-content-end">
                              <DatePicker
                                name={doc?.id}
                                selected={doc?.file?.expDate}
                                onChange={(date) =>
                                  handleAttachmentDate(date, doc?.id)
                                }
                                customInput={<ExampleCustomInput />}
                                dayClassName={() =>
                                  "example-datepicker-day-class"
                                }
                                popperClassName="example-datepicker-class"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                              />
                              {doc?.fileName != "" &&
                                doc?.file?.expDate != null && (
                                  <span class="popover__wrapper ml-1">
                                    <i class="fas fa-info-circle"></i>
                                    <div class="popover__content">
                                      <p>
                                        This file has been expiring soon, please
                                        update the file
                                      </p>
                                    </div>
                                  </span>
                                )}
                            </div>
                            {docError[ind] && (
                              <p className="form-error">{docError[ind]}</p>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>No Files</tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card d-none">
        <div className="card-header">
          <h2>Credit Limit Approval</h2>
        </div>
        <div className="card-body">
          <div className="row credit-limit-approval-row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="text-right">
                    <button type="button" className="btn credit-limit-btn">
                      <i class="fas fa-plus-square"></i> Request More Credit
                      Limit
                    </button>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                  <div>
                    <label>Credit Amount</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                  <div>
                    <label>Credit days</label>
                    <p>Dropdown here</p>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                  <div className="mt-32">
                    <button type="button" className="btn request-btn">
                      Request
                    </button>
                  </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                  <div className="text-center">
                    <p>Credit request submitted, currently processing.</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                  <div>
                    <label>Available Open Credit </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <div>
                    <label>Available LC Credit </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2">
                  <div>
                    <label>Previous Approved Open Credit </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2">
                  <div>
                    <label>Request Additional Open Credit </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                  <div>
                    <label>Supporting File </label>
                    {/* upload */}
                    <div id="file-upload-form" className="upload-btn">
                      <input
                        id="file-upload-attachment-document"
                        type="file"
                        name="commercialRegistration"
                        accept=".pdf"
                      />
                      <label for="file-upload-attachment-document" id="file-drag">
                        <p>Supporting File</p>
                        <span class="material-icons-outlined">file_upload</span>
                      </label>

                      <label className="d-none">
                        <p>fileName</p>
                        <i className="fas fa-times"></i>
                      </label>
                    </div>
                    <div className="d-none">
                      <div className="uploaded-file-name">
                        <label>
                          <div className="upload-caption">
                            <i className="fas fa-paperclip mr-3"></i>
                            Attach File
                          </div>
                        </label>
                      </div>
                      <form id="file-upload-form" className="upload-btn">
                        <input
                          id="file-upload-attachment-document"
                          type="file"
                          name="commercialRegistration"
                          accept=".pdf"
                        />
                        <label
                          for="file-upload-attachment-document"
                          id="file-drag"
                        >
                          <span class="material-icons-outlined">
                            file_upload
                          </span>
                        </label>
                      </form>
                      <button className="btn delete-icon-btn" type="button">
                        <i className="far fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                  <div className="text-right mt-3">
                    <button type="button" className="btn cancel-btn mr-2">
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn request-btn"
                      data-toggle="modal"
                      data-target="#creditLimitRequestModal"
                      disabled
                    >
                      Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerDocuments;
